export default "__VITE_ASSET__Cw07CH91__"